import AttendanceTagsApi from '@/modules/tags/infrastructure/api/AttendanceTagsClient';

export default class AttendanceTagService {
  private client: AttendanceTagsApi;

  constructor(client: AttendanceTagsApi) {
    this.client = client;
  }

  async addAttendanceTagToAgent(
    contactId: number,
    agentId: number,
    body: { channel: string; agentId: number },
  ) {
    return await this.client.addAttendanceTagToAgent(contactId, agentId, body);
  }
  async removeAttendanceTagToAgent(
    employerId: number,
    agentId: number,
    body: { channel: string; agentId: number },
  ) {
    return await this.client.removeAttendanceTagToAgent(
      employerId,
      agentId,
      body,
    );
  }
}
